// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep * {
  font-family: "Roboto", sans-serif !important;
}

table {
  border-collapse: separate;
  border-spacing: 0;
}

th.mat-header-cell,
td.mat-cell {
  padding: 0 16px !important;
  white-space: nowrap;
}

tr.mat-row:hover {
  background-color: #f5f5f5;
  cursor: pointer;
}

tr.mat-row {
  height: 52px;
}

tr.mat-header-row {
  height: 52px;
  background-color: #fafafa;
}

.deactivated-row td {
  color: #aaa !important;
  background-color: #f5f5f5 !important;
  opacity: 0.7;
}

.deactivated-row:hover td {
  background-color: #eeeeee !important;
}

/* Selection Bar styles */
.selection-bar {
  display: flex;
  align-items: center;
  background-color: #f5f5f5;
  padding: 0 16px;
  border-radius: 8px;
  margin: 10px 0;
  width: 100%;
  min-height: 48px;
}

.vertical-divider {
  width: 1px;
  height: 24px;
  background-color: #dbdbdb;
  margin: 0 12px;
}

.selection-count {
  font-weight: 500;
  color: #1c1c1c;
  font-size: 14px;
  font-weight: 400;
}

.send-link-btn {
  background-color: transparent !important;
  color: #1288ff !important;
  border: 1px solid #1288ff !important;
  border-radius: 24px !important;
  font-size: 14px !important;
  font-weight: 700 !important;
}

.send-link-btn:disabled {
  color: #999999 !important;
  border-color: #dbdbdb !important;
  cursor: not-allowed;
}

.white-spinner ::ng-deep circle {
  stroke: #999999 !important;
}

.filter-row {
  display: flex;
  align-items: center;
  gap: 16px;
}

.filter-row mat-form-field {
  width: 250px;
}

.upload-btn {
  background: linear-gradient(90deg, #00b2ff 0%, #1288ff 100%) !important;
  color: white !important;
  border-radius: 24px !important;
  font-size: 14px;
  font-weight: 600;
  padding: 6px 8px !important;
  border: none;
}

.ml-auto {
  margin-left: auto !important;
}

.filter-row mat-form-field {
  width: 250px;
}

:host ::ng-deep .filter-row .mat-form-field-wrapper {
  padding: 0 !important;
  margin: 0 !important;
}

:host ::ng-deep .filter-row .mat-form-field-subscript-wrapper {
  display: none !important;
}

:host ::ng-deep .filter-row .mat-form-field-infix {
  padding: 8px 0 !important;
  border-top: 0 !important;
  width: auto !important;
}

:host
  ::ng-deep
  .filter-row
  .mat-form-field-appearance-outline
  .mat-form-field-outline {
  color: #e0e0e0 !important;
}

:host
  ::ng-deep
  .filter-row
  .mat-form-field-appearance-outline:hover
  .mat-form-field-outline-thick,
:host
  ::ng-deep
  .filter-row
  .mat-form-field-appearance-outline.mat-focused
  .mat-form-field-outline-thick {
  color: #b0b0b0 !important;
}

.status-label {
  padding: 4px 8px;
  border-radius: 24px;
}

.status-label.invite-pending {
  background-color: #fff0d6;
  color: #fa9e00;
}

.status-label.invited {
  background-color: #e5f3ff;
  color: #44a6f3;
}

.status-label.details-submitted {
  background-color: #ecf7ed;
  color: #0a9913;
}

.status-label.processing {
  background-color: #f0f9ff;
  color: #1c1c1c;
}

.status-label.policy-issued {
  background-color: #f6f0fd;
  color: #843ce5;
}

:host ::ng-deep .mat-cell {
  color: #616161;
  font-weight: 400;
}

:host ::ng-deep .mat-header-cell {
  color: #1c1c1c;
  font-weight: 600;
  font-size: 12px;
}

:host ::ng-deep .mat-form-field-flex {
  margin-top: 0px !important;
  padding-top: 10px !important;
  height: 40px !important;
}

:host ::ng-deep .mat-form-field-appearance-outline .mat-form-field-infix {
  padding: 0 !important;
}

:host ::ng-deep .mat-input-element {
  font-size: 16px !important;
  font-weight: 400;
}

.download-container {
  position: relative;
  display: inline-block;
}

.download-btn {
  display: flex;
  align-items: center;
  gap: 4px;
}

.arrow {
  font-size: 18px;
}

.dropdown {
  position: absolute;
  top: 110%;
  right: 0;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  font-size: 14px;
  min-width: 160px;
}

.dropdown div {
  padding: 10px 14px;
  cursor: pointer;
}

.dropdown div:hover {
  background: #f5f7fa;
}

::ng-deep .mat-dialog-container {
  border-radius: 16px !important;
}

/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/careplus/careplus-imported-employees/careplus-imported-employees.component.css"],"names":[],"mappings":"AAAA;EACE,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;EACzB,oCAAoC;EACpC,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uEAAuE;EACvE,uBAAuB;EACvB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;;;;;;;;;;EAUE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,4mQAA4mQ","sourcesContent":[":host ::ng-deep * {\n  font-family: \"Roboto\", sans-serif !important;\n}\n\ntable {\n  border-collapse: separate;\n  border-spacing: 0;\n}\n\nth.mat-header-cell,\ntd.mat-cell {\n  padding: 0 16px !important;\n  white-space: nowrap;\n}\n\ntr.mat-row:hover {\n  background-color: #f5f5f5;\n  cursor: pointer;\n}\n\ntr.mat-row {\n  height: 52px;\n}\n\ntr.mat-header-row {\n  height: 52px;\n  background-color: #fafafa;\n}\n\n.deactivated-row td {\n  color: #aaa !important;\n  background-color: #f5f5f5 !important;\n  opacity: 0.7;\n}\n\n.deactivated-row:hover td {\n  background-color: #eeeeee !important;\n}\n\n/* Selection Bar styles */\n.selection-bar {\n  display: flex;\n  align-items: center;\n  background-color: #f5f5f5;\n  padding: 0 16px;\n  border-radius: 8px;\n  margin: 10px 0;\n  width: 100%;\n  min-height: 48px;\n}\n\n.vertical-divider {\n  width: 1px;\n  height: 24px;\n  background-color: #dbdbdb;\n  margin: 0 12px;\n}\n\n.selection-count {\n  font-weight: 500;\n  color: #1c1c1c;\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.send-link-btn {\n  background-color: transparent !important;\n  color: #1288ff !important;\n  border: 1px solid #1288ff !important;\n  border-radius: 24px !important;\n  font-size: 14px !important;\n  font-weight: 700 !important;\n}\n\n.send-link-btn:disabled {\n  color: #999999 !important;\n  border-color: #dbdbdb !important;\n  cursor: not-allowed;\n}\n\n.white-spinner ::ng-deep circle {\n  stroke: #999999 !important;\n}\n\n.filter-row {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.filter-row mat-form-field {\n  width: 250px;\n}\n\n.upload-btn {\n  background: linear-gradient(90deg, #00b2ff 0%, #1288ff 100%) !important;\n  color: white !important;\n  border-radius: 24px !important;\n  font-size: 14px;\n  font-weight: 600;\n  padding: 6px 8px !important;\n  border: none;\n}\n\n.ml-auto {\n  margin-left: auto !important;\n}\n\n.filter-row mat-form-field {\n  width: 250px;\n}\n\n:host ::ng-deep .filter-row .mat-form-field-wrapper {\n  padding: 0 !important;\n  margin: 0 !important;\n}\n\n:host ::ng-deep .filter-row .mat-form-field-subscript-wrapper {\n  display: none !important;\n}\n\n:host ::ng-deep .filter-row .mat-form-field-infix {\n  padding: 8px 0 !important;\n  border-top: 0 !important;\n  width: auto !important;\n}\n\n:host\n  ::ng-deep\n  .filter-row\n  .mat-form-field-appearance-outline\n  .mat-form-field-outline {\n  color: #e0e0e0 !important;\n}\n\n:host\n  ::ng-deep\n  .filter-row\n  .mat-form-field-appearance-outline:hover\n  .mat-form-field-outline-thick,\n:host\n  ::ng-deep\n  .filter-row\n  .mat-form-field-appearance-outline.mat-focused\n  .mat-form-field-outline-thick {\n  color: #b0b0b0 !important;\n}\n\n.status-label {\n  padding: 4px 8px;\n  border-radius: 24px;\n}\n\n.status-label.invite-pending {\n  background-color: #fff0d6;\n  color: #fa9e00;\n}\n\n.status-label.invited {\n  background-color: #e5f3ff;\n  color: #44a6f3;\n}\n\n.status-label.details-submitted {\n  background-color: #ecf7ed;\n  color: #0a9913;\n}\n\n.status-label.processing {\n  background-color: #f0f9ff;\n  color: #1c1c1c;\n}\n\n.status-label.policy-issued {\n  background-color: #f6f0fd;\n  color: #843ce5;\n}\n\n:host ::ng-deep .mat-cell {\n  color: #616161;\n  font-weight: 400;\n}\n\n:host ::ng-deep .mat-header-cell {\n  color: #1c1c1c;\n  font-weight: 600;\n  font-size: 12px;\n}\n\n:host ::ng-deep .mat-form-field-flex {\n  margin-top: 0px !important;\n  padding-top: 10px !important;\n  height: 40px !important;\n}\n\n:host ::ng-deep .mat-form-field-appearance-outline .mat-form-field-infix {\n  padding: 0 !important;\n}\n\n:host ::ng-deep .mat-input-element {\n  font-size: 16px !important;\n  font-weight: 400;\n}\n\n.download-container {\n  position: relative;\n  display: inline-block;\n}\n\n.download-btn {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.arrow {\n  font-size: 18px;\n}\n\n.dropdown {\n  position: absolute;\n  top: 110%;\n  right: 0;\n  background: #fff;\n  border-radius: 10px;\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);\n  font-size: 14px;\n  min-width: 160px;\n}\n\n.dropdown div {\n  padding: 10px 14px;\n  cursor: pointer;\n}\n\n.dropdown div:hover {\n  background: #f5f7fa;\n}\n\n::ng-deep .mat-dialog-container {\n  border-radius: 16px !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
